// extracted by mini-css-extract-plugin
module.exports = {"imageButton":"MaterialsTable_imageButton__1hP3N","container":"MaterialsTable_container__nYPh5","tableContainer":"MaterialsTable_tableContainer__1CwNQ"};